import React, {
  useCallback, useEffect, useMemo, useRef, useState
} from 'react';
import { PauseSharp, PlayArrowSharp } from '@mui/icons-material';
import { formatDateString } from './utils';
import { useSessionContext } from './SessionContext';

const DAYS_PER_SECOND = 30;
const PERF_DEBUG = false;

export default function TimelineScrubber() {
  const { dates, selectedDateIndex, setSelectedDateIndex } = useSessionContext();
  const [isPlaying, setIsPlaying] = useState(false);
  const [continuousValue, setContinuousValue] = useState();
  const [lastTime, setLastTime] = useState();
  const animationRef = useRef(null);

  const max = useMemo(() => (dates ? dates.length - 1 : 0), [dates]);

  useEffect(() => {
    if (continuousValue === undefined) return;
    setSelectedDateIndex(Math.round(continuousValue));
  }, [continuousValue]);

  useEffect(() => {
    if (continuousValue === undefined) {
      setContinuousValue(selectedDateIndex);
    }
  }, [selectedDateIndex]);

  const tick = useCallback((timestamp) => {
    if (lastTime) {
      const msPassed = timestamp - lastTime;
      if (PERF_DEBUG) console.log(msPassed);
      const step = (DAYS_PER_SECOND / 1000) * msPassed;
      let nextValue = (continuousValue + step) % max;
      if (nextValue >= max) nextValue = 0;
      setContinuousValue(nextValue);
    }
    setLastTime(timestamp);
    animationRef.current = requestAnimationFrame(tick);
  }, [continuousValue, setContinuousValue, max, lastTime]);

  useEffect(() => {
    if (!isPlaying) {
      setLastTime();
    }
  }, [isPlaying]);

  useEffect(() => {
    if (isPlaying) {
      animationRef.current = requestAnimationFrame(tick);
    }
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPlaying, tick]);

  return (
    <div className="frosted timeline-scrubber">
      {continuousValue === undefined ? (
        <p style={{ color: 'white' }}>Fetching data...</p>
      ) : (
        <>
          <button
            type="button"
            className="timeline-button"
            onClick={() => setIsPlaying(!isPlaying)}
          >
            {isPlaying ? <PauseSharp title="Stop" /> : <PlayArrowSharp title="Animate" />}
          </button>
          <input
            className="slider time-slider"
            type="range"
            min={0}
            max={max}
            value={continuousValue}
            onChange={(event) => setContinuousValue(parseInt(event.target.value, 10))}
          />
          <div className="timeline-date-label">

            <span>{dates ? formatDateString(dates[selectedDateIndex]) : ''}</span>
          </div>
        </>
      )}
    </div>
  );
}
